import { Warning } from "@mui/icons-material";
import React from "react";

import AnalyticsCard from "@/components/common/AnalyticsCard";

interface SummaryCardConfig {
  value: string;
  previousText: string | null;
  title: string;
  isPositive: boolean;
  subtitle: React.ReactNode;
  icon?: React.ReactNode;
  pillText: string | null;
  pillTextAsChip?: boolean;
  subtitleLoading?: boolean;
  trend?: React.ComponentProps<typeof AnalyticsCard>["trend"];
}

interface StoreInsightsSummaryCardsRowProps {
  title: string;
  cards: [SummaryCardConfig, SummaryCardConfig];
}

export const StoreInsightsSummaryCardsRow: React.FC<StoreInsightsSummaryCardsRowProps> = ({
  title,
  cards,
}) => {
  return (
    <>
      <h2 className="text-[20px] font-semibold mb-4">{title}</h2>
      <div className="flex flex-wrap gap-4">
        {cards.map((card) => (
          <div key={card.title} className="flex-1 min-w-[300px]">
            <AnalyticsCard
              value={card.value}
              previousText={card.previousText}
              title={card.title}
              isPositive={card.isPositive}
              subtitle={card.subtitle}
              icon={card.icon ?? <Warning />}
              pillText={card.pillText}
              pillTextAsChip={card.pillTextAsChip}
              showGradient={true}
              trend={card.trend}
              subtitleLoading={card.subtitleLoading}
            />
          </div>
        ))}
      </div>
    </>
  );
};
